import ConfigAccordion from "./ConfigAccordion";
export default ConfigAccordion;
export type { ConfigAccordionProps } from "./ConfigAccordion";
